"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _axios = _interopRequireDefault(require("axios"));

var _react = require("react");

var _reactRedux = require("react-redux");

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: 1rem 0 0;\n"])));

var StyledCard = (0, _styledComponents.default)(_fiverReactUiComponents.Card)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  padding: 0 1rem 1rem;\n"])));

var Wrapper = function Wrapper(_ref) {
  var _translations$confirm;

  var translations = _ref.translations,
      isDisabled = _ref.isDisabled,
      consentCheckboxes = _ref.consentCheckboxes,
      setConsetCheckboxes = _ref.setConsetCheckboxes,
      onTermsAndConditionsClicked = _ref.onTermsAndConditionsClicked,
      tenantDetails = _ref.tenantDetails;
  (0, _react.useEffect)(function () {
    _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var res;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _axios.default.get("/me");

            case 2:
              res = _context.sent;
              console.log("profileRes", res);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }, []);

  var handleAgeCheckboxChanged = function handleAgeCheckboxChanged(e) {
    console.log("handleAgeCheckboxChanged", e.target.checked);
    setConsetCheckboxes(_objectSpread(_objectSpread({}, consentCheckboxes), {}, {
      over18: e.target.checked
    }));
  };

  var handleMarketingCheckboxChanged = function handleMarketingCheckboxChanged(e) {
    console.log("handleAgeCheckboxChanged", e.target.checked);
    setConsetCheckboxes(_objectSpread(_objectSpread({}, consentCheckboxes), {}, {
      marketing: e.target.checked
    }));
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledWrapper, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledCard, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.CardTitle, {
        children: translations.termsConditions
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_fiverReactUiComponents.Alert, {
        textAlign: "left",
        margin: "0 0 1rem",
        isDanger: true,
        children: [translations.playResponsibly, " 18+"]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormRow, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormCheckbox, {
          disabled: isDisabled,
          onChange: handleAgeCheckboxChanged,
          onLabelLinkClicked: onTermsAndConditionsClicked,
          labelLinkText: translations.agreedTermsLinkText,
          label: translations.agreedTerms,
          name: "over18",
          checked: isDisabled || (consentCheckboxes === null || consentCheckboxes === void 0 ? void 0 : consentCheckboxes.over18)
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormRow, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FormCheckbox, {
          disabled: isDisabled,
          onChange: handleMarketingCheckboxChanged,
          label: translations === null || translations === void 0 ? void 0 : (_translations$confirm = translations.confirmMarketing) === null || _translations$confirm === void 0 ? void 0 : _translations$confirm.replace("$1", tenantDetails === null || tenantDetails === void 0 ? void 0 : tenantDetails.complianceName),
          name: "marketing",
          checked: isDisabled || (consentCheckboxes === null || consentCheckboxes === void 0 ? void 0 : consentCheckboxes.marketing)
        })
      })]
    })
  });
};

var _default = Wrapper;
exports.default = _default;